import type { MapMarkersProps } from "./map-markers.type";

import MapCluster from "../map-cluster";
import { MapInfoWindow } from "../map-info-window";
import MapMarker from "../map-marker";

import { useMapMarkers } from "./map-markers.hook";

const MapMarkers = ({ mapId, markers, noInfoWindow }: MapMarkersProps) => {
  const {
    activeMarker,
    setActiveMarker,
    activeAdvancedMarker,
    advancedMarkers,
    onAdvancedMarkerRender,
  } = useMapMarkers({ mapId, markers });

  return (
    <>
      <MapCluster advancedMarkers={advancedMarkers} />
      {markers.map((marker) => (
        <MapMarker
          key={marker.key}
          marker={marker}
          onAdvancedMarkerRender={onAdvancedMarkerRender}
          onMarkerClick={
            !noInfoWindow ? (marker) => setActiveMarker(marker) : undefined
          }
        />
      ))}
      {!noInfoWindow && activeMarker && (
        <MapInfoWindow
          marker={activeMarker}
          anchor={activeAdvancedMarker}
          onClose={() => setActiveMarker(null)}
        />
      )}
    </>
  );
};

export default MapMarkers;
